module.exports = __webpack_public_path__ + "img/usuario.59cfab96.svg";